import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "#444545",
  "stroke-linecap": "round",
  "stroke-width": "3",
  viewBox: "0 0 240 240"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M237.5 1.5H1.5v236h236z" }, null, -1),
    _createElementVNode("path", {
      "stroke-linecap": "butt",
      d: "M119.5 237.5c0-65.142-52.858-118-118-118m118-118c0 65.142 52.858 118 118 118"
    }, null, -1)
  ])))
}
export default { render: render }